const INIT_SHARE_INFO_STATE = {
  loading: false,
  error: null,
  data: {},
};
export const patientShareInformationReducer = (
  state = INIT_SHARE_INFO_STATE,
  { type, payload }
) => {
  switch (type) {
    case "SHARE_INFORMATION_LOADING":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "SHARE_INFORMATION_SUCSES":
      return {
        ...state,
        loading: false,
        error: null,
        data: payload,
      };
    case "SHARE_INFORMATION_ERORR":
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
};
export const patientStopShareInformationReducer = (
  state = INIT_SHARE_INFO_STATE,
  { type, payload }
) => {
  switch (type) {
    case "STOP_SHARE_INFORMATION_LOADING":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "STOP_SHARE_INFORMATION_SUCSES":
      return {
        ...state,
        loading: false,
        error: null,
        data: payload,
      };
    case "STOP_SHARE_INFORMATION_ERORR":
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
};
